import styled, {css} from 'styled-components';
import { theme } from '../styles/theme';


const GlobalButtonArrow = styled.a`
    cursor: pointer;
    text-decoration: none;
    position: relative;
    background: transparent;
    display: inline-flex;
    flex-direction: row;
    &:hover {
        span {
            background-color: ${props => props.bgColorOver};
        }
    }
`

const GlobalButtonText = styled.div`
    color: white;
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    z-index: 1;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: .035px;
    font-weight: 900;
    font-style: normal;
    span {
        background-color: ${props => props.bgColor};
        align-items: center;
        display: inline-flex;
        justify-content: center;
        padding: 6px 26px 5px;
        transition: .3s ease-in-out;
        width: 100%;
        height: 100%;
        border-radius: 3px;
    }
`



export default function ButtonArrow({
    link, 
    bgColor, 
    bgColorOver, 
    btnText
}) {
    return (
        <GlobalButtonArrow
            href={link}
            bgColor={bgColor ? bgColor : theme.palette.main500} 
            bgColorOver={bgColorOver ? bgColorOver : theme.palette.grey800}
        >
            <GlobalButtonText 
                bgColor={bgColor ? bgColor : theme.palette.main500}
                bgColorOver={bgColorOver ? bgColorOver : theme.palette.grey800}
            >
                <span 
                    bgColor={bgColor ? bgColor : theme.palette.main500}
                    bgColorOver={bgColorOver ? bgColorOver : theme.palette.grey800}
                >
                    {btnText}
                </span>
            </GlobalButtonText>
        </GlobalButtonArrow>
    )
}